export default function Header() {
  const header = document.querySelector(".site-header");

  console.log(header);
}
